"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.HulylakeStorage = void 0;
const core_1 = require("@hcengineering/core");
const upload_1 = require("../upload");
const getPathname = (url) => {
    const base = window?.location?.href ?? 'http://localhost';
    return new URL(url, base).pathname;
};
/** @public */
class HulylakeStorage {
    baseUrl;
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    getFileUrl(workspace, file, filename) {
        const path = `/api/${workspace}/${file}`;
        return (0, core_1.concatLink)(this.baseUrl, path);
    }
    getCookiePath(workspace) {
        const url = (0, core_1.concatLink)(this.baseUrl, `/api/${workspace}`);
        return getPathname(url);
    }
    async getFileMeta(token, workspace, file) {
        return {};
    }
    async deleteFile(token, workspace, file) {
        const url = this.getFileUrl(workspace, file);
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Failed to delete file');
        }
    }
    async uploadFile(token, workspace, uuid, file, options) {
        const url = this.getFileUrl(workspace, uuid);
        await (0, upload_1.uploadXhr)({
            url,
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': file.type,
                'Content-Length': file.size.toString()
            },
            body: file
        }, options);
    }
}
exports.HulylakeStorage = HulylakeStorage;
//# sourceMappingURL=hulylake.js.map